import Vue from 'vue';
import store from '../store/store';

class JwtService {
  static refreshToken() {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${process.env.VUE_APP_API_URL}/refresh-token`).then(({ data }) => {
        if (data.token) {
          window.localStorage.setItem('access_token', data.token);
          store.dispatch('auth/authenticate');
          resolve({ update: true });
        }
        reject({ error: true });
      });
    });
  }
}

export default JwtService;
